import type { InvoiceStatus } from './useStripeInvoices';

const STYLES: Record<InvoiceStatus, { bg: string; color: string; border: string }> = {
  draft: { bg: 'var(--dash-hover-bg)', color: 'var(--dash-text-muted)', border: 'var(--dash-border)' },
  sent: { bg: 'rgba(59,130,246,0.1)', color: '', border: '' },
  paid: { bg: 'rgba(16,185,129,0.1)', color: '', border: '' },
  overdue: { bg: 'rgba(239,68,68,0.1)', color: '', border: '' },
  cancelled: { bg: 'var(--dash-hover-bg)', color: 'var(--dash-text-dim)', border: 'var(--dash-border)' },
};

const ACCENT_CLASSES: Partial<Record<InvoiceStatus, string>> = {
  sent: 'text-blue-400 border-blue-500/30',
  paid: 'text-emerald-400 border-emerald-500/30',
  overdue: 'text-red-400 border-red-500/30',
};

const LABELS: Record<InvoiceStatus, string> = {
  draft: 'Draft',
  sent: 'Sent',
  paid: 'Paid',
  overdue: 'Overdue',
  cancelled: 'Cancelled',
};

interface Props {
  status: InvoiceStatus;
  dueDate?: string | null;
}

export default function InvoiceStatusBadge({ status, dueDate }: Props) {
  const isOverdue = status === 'sent' && dueDate && new Date(dueDate) < new Date();
  const key = isOverdue ? 'overdue' : status;
  const style = STYLES[key] || STYLES.draft;
  const label = LABELS[key] || status;
  const accentClass = ACCENT_CLASSES[key];

  if (accentClass) {
    return (
      <span
        className={`inline-block px-2 py-0.5 text-xs font-mono font-medium border rounded ${accentClass}`}
        style={{ background: style.bg }}
      >
        {label}
      </span>
    );
  }

  return (
    <span
      className="inline-block px-2 py-0.5 text-xs font-mono font-medium rounded"
      style={{
        background: style.bg,
        color: style.color,
        border: `1px solid ${style.border}`,
      }}
    >
      {label}
    </span>
  );
}
